import { FC } from "react";
import { G, Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdFilter: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 100 100" fill="none" {...props}>
      <G>
        <Path
          d="M41.5,78.56h17c0.83,0,1.5,0.67,1.5,1.5l0,0c0,0.83-0.67,1.5-1.5,1.5h-17c-0.83,0-1.5-0.67-1.5-1.5l0,0   C40,79.23,40.67,78.56,41.5,78.56z"
          fill="currentColor"
        />
      </G>
      <G>
        <Path
          d="M31.5,58.56h37c0.83,0,1.5,0.67,1.5,1.5v0c0,0.83-0.67,1.5-1.5,1.5h-37c-0.83,0-1.5-0.67-1.5-1.5v0   C30,59.23,30.67,58.56,31.5,58.56z"
          fill="currentColor"
        />
      </G>
      <G>
        <Path
          d="M21.5,38.56h57c0.83,0,1.5,0.67,1.5,1.5v0c0,0.83-0.67,1.5-1.5,1.5h-57c-0.83,0-1.5-0.67-1.5-1.5v0   C20,39.23,20.67,38.56,21.5,38.56z"
          fill="currentColor"
        />
      </G>
      <G>
        <Path
          d="M11.5,18.56h77c0.83,0,1.5,0.67,1.5,1.5v0c0,0.83-0.67,1.5-1.5,1.5h-77c-0.83,0-1.5-0.67-1.5-1.5v0   C10,19.23,10.67,18.56,11.5,18.56z"
          fill="currentColor"
        />
      </G>
    </Svg>
  );
};

export default PdFilter;
